import { PanelFrame } from './floating';

const GROUPS: [string, [string, string][]][] = [
  [
    'Navigate',
    [
      ['Wheel / pinch', 'Zoom at the cursor'],
      ['Shift + wheel', 'Pan'],
      ['Space + drag, middle drag, H', 'Pan'],
      ['+ / - / 0', 'Zoom in / out / 100%'],
      ['1 / 2', 'Fit all / fit selection'],
    ],
  ],
  [
    'Create',
    [
      ['N / T / X', 'Sticky note / title / text block'],
      ['Shift+B / D / K', 'Table / to-do list / kanban'],
      ['S', 'Shape (drag; Shift = square)'],
      ['F', 'Frame (drag; moving a frame carries its contents)'],
      ['P / U / B', 'Pen (pressure) / fineliner (constant width) / brush pen'],
      ['M / G', 'Highlighter / fill (paints the inside of a drawn loop)'],
      ['E', 'Eraser (partial, or whole strokes: set in the draw options)'],
      ['L', 'Lasso: select strokes (draw a loop; Shift adds; tap picks one)'],
      ['Shift + draw', 'Straight line in 15 degree steps (pausing at the end of a line straightens it too)'],
      ['Alt + click', 'While drawing: take a colour from the board for the pen'],
      ['C', 'Cut out a piece of an image (lasso, rectangle or ellipse; soft edge and hole-in-source options)'],
      ['R', 'Sketch sheet: paint the selected sheet, or place a new one (A4 at 300 dpi by default)'],
      ['I', 'Import images or attach files'],
      ['Ctrl + V', 'Paste at the mouse cursor: items (also from another board, split pane or tab), images, text (note) or a URL (link card; a board link makes a board card)'],
    ],
  ],
  [
    'Edit',
    [
      ['Double-click', 'Edit text, open link or board card, download file'],
      ['Enter', 'Edit the selected text item'],
      ['Ctrl + Z / Ctrl + Shift + Z', 'Undo / redo'],
      ['Ctrl + C / X / D', 'Copy / cut (works across boards and tabs) / duplicate'],
      ['Delete', 'Delete selection'],
      ['Arrows (+ Shift)', 'Nudge 1 px (10 px)'],
      ['[ / ] and Ctrl + [ / ]', 'Z-order step / to back, to front'],
      ['Ctrl + G / Ctrl + Shift + G', 'Group / ungroup'],
      ['Ctrl + L', 'Lock / unlock'],
      ["'", 'Toggle snapping (hold Alt to bypass)'],
      ['Alt while resizing', 'Free aspect on images'],
      ['Alt + drag (Cmd + drag on a Mac)', 'Drag a copy, leaving the original in place'],
      ['Shift while rotating', 'Snap to 15°'],
    ],
  ],
  [
    'Paint (on a sketch sheet)',
    [
      ['Double-click a sheet, or Enter', 'Start painting on it'],
      ['P / F / B / E', 'Pencil / fineliner / brush / eraser'],
      ['G / I', 'Fill / eyedropper (Alt + press picks with any brush)'],
      ['[ / ]', 'Smaller / larger brush'],
      ['Ctrl + Z / Ctrl + Shift + Z', 'Undo / redo the last stroke (or the last board change, whichever is newer)'],
      ['Esc', 'Stop painting'],
    ],
  ],
  [
    'Touch',
    [
      ['Two-finger tap', 'Undo'],
      ['Three-finger tap', 'Redo'],
      ['Pinch / two-finger drag', 'Zoom / pan'],
      ['Two-finger twist', 'Rotate the canvas (snaps every 45°)'],
      ['Very fast two-finger pinch', 'Reset rotation and zoom to 100%'],
      ['Tap', 'Select (drag moves a selected item; elsewhere pans)'],
      ['Drag the options title bar', 'Float the tool options anywhere; the dock button puts them back'],
    ],
  ],
  [
    'Select',
    [
      ['Click / Shift + click', 'Select / add or remove'],
      ['Drag on empty canvas', 'Marquee select'],
      ['Ctrl + click', 'Pick one item out of a group'],
      ['Ctrl + A', 'Select all'],
      ['Esc', 'Clear selection; again: back to Select'],
      ['?', 'This list'],
    ],
  ],
];

export function ShortcutsPanel({ onClose }: { onClose: () => void }) {
  return (
    <PanelFrame kind="shortcuts" title="Keyboard shortcuts" className="shortcuts-panel" onClose={onClose}>
      <div className="shortcuts-body">
        {GROUPS.map(([title, rows]) => (
          <section key={title}>
            <div className="insp-label">{title}</div>
            <table className="shortcuts">
              <tbody>
                {rows.map(([keys, what]) => (
                  <tr key={keys}>
                    <td>
                      <kbd>{keys}</kbd>
                    </td>
                    <td>{what}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </section>
        ))}
      </div>
    </PanelFrame>
  );
}
